import { createContext, useContext } from 'react';

import { DEFAULT_RINGTONE, TRingtoneNames } from '@cloud-wave/neon-common-lib/app';

import { ValueOf } from 'lib/core/types';

import INCOMING_TASK_PLACEMENTS from 'lib/common/constants/incomingTaskPlacements';
import WORKSPACE_LAYOUTS from 'lib/common/constants/workspaceLayouts';

import { isWindows } from 'lib/common/utils/isWindows';

export enum LogStreamFilter {
  ALL = 'ALL',
  CONNECT = 'CONNECT',
  NEONNOW = 'NEONNOW',
}

const DEFAULT_INCOMING_TASK_PLACEMENT = isWindows() ? INCOMING_TASK_PLACEMENTS.TOP : INCOMING_TASK_PLACEMENTS.BOTTOM;
const DEFAULT_ENHANCED_LOGGING_STATE = false;

type TPreferencesContext = {
  state: {
    defaultWorkspaceLayout: ValueOf<typeof WORKSPACE_LAYOUTS>;
    incomingTaskPlacement: ValueOf<typeof INCOMING_TASK_PLACEMENTS>;
    ringtone: TRingtoneNames;
    enhancedLoggingEnabled: boolean;
    incomingChatNotificationsEnabled: boolean;
    logStreamFilter?: LogStreamFilter;
  };
  actions: {
    setDefaultWorkspaceLayout: (layout: ValueOf<typeof WORKSPACE_LAYOUTS>) => void;
    setIncomingTaskPlacement: (incomingTaskPlacement: ValueOf<typeof INCOMING_TASK_PLACEMENTS>) => void;
    setRingtone: (ringtone: string) => void;
    setEnhancedLoggingEnabled: (enhancedLoggingEnabled: boolean) => void;
    setIncomingChatNotificationsEnabled: (incomingChatNotificationsEnabled: boolean) => void;
    setLogStreamFilter: (logStreamFilter?: LogStreamFilter) => void;
  };
};

const Context = createContext<TPreferencesContext>({
  state: {
    incomingTaskPlacement: DEFAULT_INCOMING_TASK_PLACEMENT,
    defaultWorkspaceLayout: WORKSPACE_LAYOUTS.THREE_COLUMNS,
    ringtone: DEFAULT_RINGTONE,
    enhancedLoggingEnabled: DEFAULT_ENHANCED_LOGGING_STATE,
    incomingChatNotificationsEnabled: false,
    logStreamFilter: undefined,
  },
  actions: {
    setDefaultWorkspaceLayout: () => {},
    setIncomingTaskPlacement: () => {},
    setRingtone: () => {},
    setEnhancedLoggingEnabled: () => {},
    setLogStreamFilter: () => {},
    setIncomingChatNotificationsEnabled: () => {},
  },
});

export default Context;

export const usePreferencesContext = () => useContext(Context);
